import { _, Component, Container, React } from "utils";
import { Loading } from "components";
import { App, Creators, FairStore, EventStore } from "model";
import { withRouter } from "react-router-dom";
import "./eventdetails.less";

class EventDetails extends Component {
  static getStores() {
    return [EventStore, FairStore];
  }

  static calculateState() {
    return {
      details: EventStore.getDetails(),
    };
  }

  componentDidMount() {
    var { eventId } = this.props.match.params;
    Creators.loadEventDetails(eventId);
  }

  render() {
    var { details } = this.state;

    if (details === null || details === undefined) {
      return <Loading description={_("Loading") + "..."} />;
    }

    return (
      <div className="job-details">
        <div>
          <h1>{details.title}</h1>
          <div className="card">
            <div hidden={details.hideHeader == true} className="card-header">
              <div className="row">
                <div className="col-9">
                  <h5 className="card-title">{details.subtitle}</h5>
                </div>
              </div>
            </div>
            <div>
              <div
                className="job-content"
                dangerouslySetInnerHTML={{ __html: details.content }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Container.create(EventDetails));



// WEBPACK FOOTER //
// ./src/modules/components/eventdetails.js